import { render, staticRenderFns } from "./BlueChallenge.vue?vue&type=template&id=4c847464&scoped=true&"
var script = {}
import style0 from "./BlueChallenge.vue?vue&type=style&index=0&id=4c847464&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c847464",
  null
  
)

export default component.exports